import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Download, Loader2 } from 'lucide-react'
import { useWeightEntries } from '../../../hooks/useWeightEntries'
import { useBodyMeasurements } from '../../../hooks/useBodyMeasurements'
import {
  weightEntriesToCsv,
  measurementsToCsv,
  downloadCsv,
} from '../../../lib/csvExport'

export function ExportButton() {
  const { t } = useTranslation()
  const { entries } = useWeightEntries()
  const { measurements } = useBodyMeasurements()
  const [exporting, setExporting] = useState(false)

  const hasData = entries.length > 0 || measurements.length > 0

  const handleExport = async () => {
    if (!hasData || exporting) return
    setExporting(true)

    const today = new Date().toLocaleDateString('en-CA') // YYYY-MM-DD

    if (entries.length > 0) {
      downloadCsv(`phoenix-weights-${today}.csv`, weightEntriesToCsv(entries))
    }
    if (measurements.length > 0) {
      // Small delay between downloads so browsers don't block the second one
      await new Promise((resolve) => setTimeout(resolve, 200))
      downloadCsv(`phoenix-measurements-${today}.csv`, measurementsToCsv(measurements))
    }

    setExporting(false)
  }

  return (
    <button
      onClick={handleExport}
      disabled={!hasData || exporting}
      className="p-2 rounded-lg hover:bg-app-primary-100 dark:hover:bg-app-primary-900/30 text-muted-foreground hover:text-app-primary-500 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      aria-label={t('phoenixTracker.export.exportData')}
      title={t('phoenixTracker.export.exportData')}
    >
      {exporting ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <Download className="w-5 h-5" />
      )}
    </button>
  )
}
